import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postProjectList: (params: ProjectListReqDto): Promise<ProjectListResDto> =>
    request({
      url: endpoints.project.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postProjectListExcel: (params: ProjectListReqDto): Promise<ProjectListExcelResDto> =>
    request({
      url: endpoints.project.listexcel,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectConsultList: (params: ProjectListReqDto): Promise<ProjectListResDto> =>
    request({
      url: endpoints.project.consult.list,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postProjectDropList: (params: ProjectListReqDto): Promise<ProjectListResDto> =>
    request({
      url: endpoints.project.drop.list,
      method: 'post',
      data: paramsToFormData(params),
    }),        
  postProjectInsert: (params: ProjectSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectUpdate: (params: ProjectSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.update,
      method: 'post',
      data: paramsToFormData(params),
    }),        
  postProjectDelete: (params: ProjectDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.delete,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectInfo: (params: ProjectInfoReqDto): Promise<ProjectInfoResDto> =>
    request({
      url: endpoints.project.info,
      method: 'post',
      data: paramsToFormData(params),
    }),  
    postProjectScheduleList: (params: ProjectInfoReqDto): Promise<ProjectScheduleListResDto> =>
    request({
      url: endpoints.project.schedule.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
    postB2cScheduleList: (params: ProjectInfoReqDto): Promise<ProjectScheduleListResDto> =>
    request({
      url: endpoints.b2c.schedule.list,
      method: 'post',
      data: paramsToFormData(params),
    }),          
  postProjectScheduleInfo: (params: ProjectInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.project.schedule.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectScheduleInsert: (params: ProjectScheduleSaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.project.schedule.add,
      method: 'post',
      data: JSON.stringify(params),
    }, 
    {content_type:'application/json'}),     
  postProjectScheduleUpdate: (params: ProjectScheduleSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.update,
      method: 'post',
      data: JSON.stringify(params),
    }, 
    {content_type:'application/json'}),        
  postProjectScheduleDelete: (params: ProjectDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.delete,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postStandbyScheduleInfo: (params: ProjectInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.project.schedule.standby.info,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postStandbyScheduleInsert: (params: StandbyScheduleSaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.project.schedule.standby.add,
      method: 'post',
      data: JSON.stringify(params),
    }, 
    {content_type:'application/json'}),     
  postStandbyScheduleUpdate: (params: StandbyScheduleSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.standby.update,
      method: 'post',
      data: JSON.stringify(params),
    }, 
    {content_type:'application/json'}),        
  postStandbyScheduleDelete: (params: ProjectDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.standby.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postStandbyProjectList: (params: StandbyProjectListReqDto): Promise<CommonNullResDto> =>
    request({
      url: endpoints.project.schedule.standby.projectList,
      method: 'post',
      data: paramsToFormData(params),
    }),                       
  postProjectMemoList: (params: ProjectDeleteReqDto): Promise<ProjectMemoResDto> =>
    request({
      url: endpoints.project.memo.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectMemoInfo: (params: ProjectMemoInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.project.memo.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectMemoInsert: (params: ProjectMemoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.memo.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectMemoUpdate: (params: ProjectMemoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.memo.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postProjectOperatorInfo: (params: ProjectInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.project.operator.info,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectOperatorSave: (params: ProjectOperatorSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.operator.save,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectOperatorDelete: (params: ProjectOperatorDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.operator.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectScheduleCheck: (params: ProjectScheduleCheckReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.check,
      method: 'post',
      data: paramsToFormData(params),
    }), 
    postProjectScheduleCheckD: (params: ProjectScheduleCheckReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.checkd,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectAskList: (params: ProjectAskListReqDto): Promise<ProjectAskListResDto> =>
    request({
      url: endpoints.project.ask.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectAskInfo: (params: ProjectAskReqDto): Promise<ProjectAskInfoResDto> =>
    request({
      url: endpoints.project.ask.info,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postProjectAskInsert: (params: ProjectAskSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectAskUpdate: (params: ProjectAskSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.update,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postProjectAskDelete: (params: ProjectAskReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postProjectAskUpdateCheck: (params: ProjectAskSaveCheckReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.updatecheck,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectAskNoteInfo: (params: ProjectAskNoteReqDto): Promise<ProjectAskNoteInfoResDto> =>
    request({
      url: endpoints.project.ask.note.info,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postProjectAskNoteInsert: (params: ProjectAskNoteSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.note.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectAskNoteUpdate: (params: ProjectAskNoteSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.note.update,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postProjectAskNoteFileUpdate: (params: ProjectAskNoteSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.ask.note.filesave,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postProjectInsertFromAsk: (params: ProjectAskSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.addfromask,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectDiagnoseInfo: (params: ProjectInfoReqDto): Promise<ProjectDiagnoseInfoResDto> =>
    request({
      url: endpoints.project.diagnose.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectDiagnoseInsert: (params: ProjectDiagnoseSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.diagnose.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectDiagnoseUpdate: (params: ProjectDiagnoseSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.diagnose.update,
      method: 'post',
      data: paramsToFormData(params),
    }),        
  postProjectDiagnoseDelete: (params: ProjectDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.diagnose.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postNextProjectList: (params: CommonIdReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.project.next_project,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postProjectDiagnoseCopy: (params: ProjectDailySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.diagnose.copy,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postOnoEMailSend: (params: OnoEMailContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.project.schedule.ono.mailsend,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postOnoEMailContent: (params: OnoMailContentReqDto): Promise<OnoEMailContentResDto> =>
    request({
      url: endpoints.project.schedule.ono.email,
      method: 'post',
      data: paramsToFormData(params),
    }),      
};
         
